import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { initializeSentry, SentryErrorBoundary } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import startApp from './actions/startApp';
import RootComponent from './components/RootComponent';
import { store } from './store';
import { chTheme, darkTheme, lightTheme } from './themes';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((user) => {
  if (user) store.dispatch(startApp());
});

const root = createRoot(document.querySelector('.root-anchor')!);
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <div>
        <Provider store={store}>
          <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme} chTheme={chTheme}>
            <RootComponent />
          </ParagonThemeProvider>
        </Provider>
      </div>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
